import { c as _c } from "react/compiler-runtime";
import { Box, Button, Center, Separator, Heading, HStack, Icon, Image, SimpleGrid, Text, Dialog } from '@chakra-ui/react';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import React from 'react';
import { LuCirclePlay } from 'react-icons/lu';
const items = [{
  title: 'Problem Statement',
  description: 'Video Lesson',
  href: `/courses/pitch-deck-bootcamp/problem-statement/introduction`,
  imageUrl: '/assets/courses/pitch-deck-bootcamp/problem-statement.jpeg'
}, {
  title: 'Solution Statement',
  description: 'Video Lesson',
  href: `/courses/pitch-deck-bootcamp/solution-statement/introduction`,
  imageUrl: '/assets/courses/pitch-deck-bootcamp/solution-statement.jpeg'
}, {
  href: `/courses/pitch-deck-bootcamp/market-size/introduction`,
  title: 'Market Size',
  description: 'Video Lesson',
  imageUrl: '/assets/courses/pitch-deck-bootcamp/solution-statement.jpeg'
}, {
  title: 'Traction',
  href: `/courses/pitch-deck-bootcamp/traction/introduction`,
  description: 'Video Lesson',
  imageUrl: '/assets/courses/pitch-deck-bootcamp/traction.jpeg'
}, {
  title: 'Raise Amount',
  href: `/courses/pitch-deck-bootcamp/funding/introduction`,
  description: 'Video Lesson',
  imageUrl: '/assets/courses/pitch-deck-bootcamp/funding.jpeg'
}, {
  title: 'Pitching Investors',
  href: `/courses/pitching-investors`,
  description: 'Video Lesson',
  imageUrl: '/assets/courses/pitch-deck-bootcamp/pitching-investors.jpeg'
}];
export const HelpModal: React.FC<{
  showHelpModal: boolean;
  setShowHelpModal: (showHelpModal: boolean) => void;
}> = props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = t1 => {
      const {
        open
      } = t1;
      return props.setShowHelpModal(open);
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dialog.Backdrop />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dialog.CloseTrigger />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Heading fontSize="3xl" textAlign="center" textStyle="heroGradient">Let's get you back on track.</Heading>;
    t4 = <Heading marginY={2} textAlign="center">Here are some resources to help define your pitch.</Heading>;
    t5 = <Separator marginY={4} />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [1, 1, 2];
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SimpleGrid columns={t6} gap={4}>{items.map(_temp)}</SimpleGrid>;
    t8 = <Separator marginY={4} />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Dialog.Positioner><Dialog.Content maxWidth="container.lg"><Dialog.Body bgColor="colorPalette.container" borderRadius="lg">{t2}<Box padding={8}>{t3}{t4}{t5}{t7}{t8}<Center><Button asChild={true} variant="cta"><NextLink href="/events/96f7d68e-79d7-4a91-adf6-9aa210885be9" target="_blank">Still Stuck? Schedule a 1-1 Session</NextLink></Button></Center></Box></Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== props.showHelpModal || $[12] !== t0) {
    t10 = <Dialog.Root open={props.showHelpModal} onOpenChange={t0}>{t1}{t9}</Dialog.Root>;
    $[11] = props.showHelpModal;
    $[12] = t0;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};
function _temp(item, idx) {
  return <HStack asChild={true} bgColor="blackAlpha.400" border="1px solid transparent" borderRadius={6} gap={4} padding={4} transition="all 150ms ease-out" _hover={{
    borderColor: "purpleLightAlpha.500",
    bgColor: "blackAlpha.400"
  }}><NextLink href={item.href || "#"} target="_blank"><Image alt={item.title || "Image"} borderRadius="4" maxWidth="120px" src={item.imageUrl || "#"} /><Box width="full"><Heading size="md">{item.title}</Heading><Text fontSize="sm">{item.description}</Text></Box><Icon asChild={true} _hover={{
        opacity: 1
      }} boxSize={6} opacity={0.25}><LuCirclePlay /></Icon></NextLink></HStack>;
}